import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PaginatorModule } from "../../elementi-strutturali/paginator/paginator.module";
import { InputSearchModule } from "../../elementi-strutturali/input-search/input-search.module";
import { ServiceListLoaderComponent } from "./service_list_loader.component";
import { CardComponent } from "src/app/shared/components/card/card.component";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";


@NgModule({
  imports: [CommonModule, PaginatorModule, InputSearchModule, CardComponent, RouterModule],
  declarations: [ServiceListLoaderComponent],
  exports: [ServiceListLoaderComponent],

})
export class ServiceListLoaderModule {
  static component = ServiceListLoaderComponent
}